var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-row',{attrs:{"justify":"space-around"}},[_c('v-progress-circular',{attrs:{"indeterminate":"","size":"150","width":"5"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }